
// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { MenuDetailsService } from './services/menu-details.service';
import { MenuDetailsComponent } from './menu-details.component';
import { PermissionModule } from "../../../permission/permission.module";

@NgModule({
    imports: [
        CommonModule,
        PermissionModule
    ],
    exports: [
        MenuDetailsComponent,
    ],
    declarations: [
        MenuDetailsComponent,
    ],
    providers: [
        MenuDetailsService,
    ],
})
export class MenuDetailsModule { }
